<template>
    <div class="container">
        <el-card style="width: 100%">
            <div slot="header">
                <span>{{$t('修改密码')}}</span>
            </div>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="150px">
                <el-form-item :label="$t('旧密码')" prop="oldPass">
                    <el-input type="password" v-model="form.oldPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('新密码')" prop="newPass">
                    <el-input type="password" v-model="form.newPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('确认密码')" prop="checkPass">
                    <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="doSubmit">{{$t('提交')}}</el-button>
                    <el-button @click="doCancel">{{$t('取消')}}</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<i18n locale="en" lang="yaml">
    "修改密码": "Change Password"
    "旧密码": "Old Password"
    "新密码": "New Password"
    "确认密码": "Confirm Password"
    "请输入原始密码": "Please enter the old password"
    "请输入新密码": "Please enter the new password"
    "两次输入密码不一致": "The confirm password is different"
    "长度在 14 到 20 个字符": "The length is between 14 and 20 characters"
    "密码修改成功，请重新登录！": "Password modified successfully, please login again!"
</i18n>

<script>
    import qs from 'qs';

    export default {
        data() {
            let validatePass = (rule, value, callback) => {
                if (value !== this.form.newPass) {
                    callback(new Error(this.$t('两次输入密码不一致')));
                } else {
                    callback();
                }
            };

            return {
                form: {},
                rules: {
                    oldPass: [
                        {required: true, message: this.$t("请输入原始密码")},
                    ],
                    newPass: [
                        {required: true, message: this.$t("请输入新密码")},
                        {min: 14, max: 20, message: this.$t('长度在 14 到 20 个字符')}
                    ],
                    checkPass: [
                        {validator: validatePass}
                    ]
                }
            }
        },
        methods: {
            doSubmit() {
                this.$utils.submit(this.$refs.form, "/index/changepass", qs.stringify(this.form), () => {
                    this.$message.success(this.$t("密码修改成功，请重新登录！"));
                    this.$root.logOut();
                })
            },
            doCancel() {
                window.history.go(-1);
            }
        }
    }
</script>

<style scoped>
    .container {
        width: 600px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
</style>